CrmOrganizationsConfigurationController.$inject = ['$scope', 'TopToolbarFactory', 'organization',
  '$stateParams', 'CrmFactory', 'company', 'AlertingFactory', '$q', 'CrmStrategiesFactory',
  'configurationPageFreshData', 'UserFactory'];
export function CrmOrganizationsConfigurationController($scope, TopToolbarFactory, organization,
  $stateParams, CrmFactory, company, AlertingFactory, $q, CrmStrategiesFactory,
  configurationPageFreshData, UserFactory) {

  $scope.registerUpdate = registerUpdate;
  init();

  function hasSalesforceWidgetInvalidValues() {
    if ($scope.organization.configuration.widget && (
      $scope.organization.configuration.widget.width.value===null || $scope.organization.configuration.widget.height.value===null
    )) {
      return true;
    }
    return false;
  }

  function registerUpdate() {
    if (angular.equals($scope.organization, $scope.savedOrganization) || 
        hasSalesforceWidgetInvalidValues() ) {
      $scope.configurationHasChanged = false;
    }
    else {
      $scope.configurationHasChanged = true;
    }
  }

  function saveConfiguration() {
    $scope.isSaving = true;
    CrmFactory.updateOrganization(company.id, $scope.organization)
      .then(
        response => {
          $scope.configurationHasChanged = false;
          $scope.savedOrganization = angular.copy($scope.organization);
          AlertingFactory.success('crm/configuration/update_success');
        },
        AlertingFactory.httpErrorHandler())
      .finally(() => $scope.isSaving = false);
  }

  function updateSaveButton() {
    TopToolbarFactory.updateButtonText($scope.isSaving ? 'saving' : 'save', $scope);
    TopToolbarFactory.updateButtonDisable(!$scope.configurationHasChanged || $scope.isSaving, $scope);
  }

  function init() {
    // Setup toolbar
    TopToolbarFactory.setTitleTranslation('crm/organizations/configuration/title', $scope);
    TopToolbarFactory.setButton('save', saveConfiguration, $scope);
    const goBackTranslationKey = 'back';
    const uisref = 'auth.alcmeon.fuse.parameters.crm.organizations';
    TopToolbarFactory.setGoBackLink(goBackTranslationKey, uisref, $scope);

    // Init organization and save stuff
    $scope.company = company;
    $scope.organization = organization;
    $scope.savedOrganization = angular.copy($scope.organization);
    $scope.configurationHasChanged = false;
    $scope.$watch('isSaving', updateSaveButton);
    $scope.$watch('configurationHasChanged', updateSaveButton);

    $scope.$watch('organization.configuration', registerUpdate, true);
    $scope.$watch('organization.name', registerUpdate, true);
    $scope.$watch('organization.is_production', registerUpdate, true);

    $scope.contactSearchFormTranslateKey = 'crm/organizations/configuration/' +
                                           organization.configuration.contact_object_name + '-search-form';

    $scope.contactProfileDisplayTranslateKey = 'crm/organizations/configuration/' +
                                               organization.configuration.contact_object_name + '-profile-display';

    $scope.contactDirectSearchTranslateKey = 'crm/organizations/configuration/' +
                                             organization.configuration.contact_object_name + '-direct-search';

    $scope.contactCreationFormTranslateKey = 'crm/organizations/configuration/' +
                                             organization.configuration.contact_object_name + '-creation-form';

    $scope.canMakeIndirectSearch = CrmStrategiesFactory.getStrategy($stateParams.crmType).canMakeIndirectSearch();
    $scope.newContactCreationMode = CrmStrategiesFactory.getStrategy($stateParams.crmType).getNewContactCreationMode(organization);

    // Load fresh objects description and available queues
    $scope.configurationPageFreshData = configurationPageFreshData;
    $scope.organization.object_description = configurationPageFreshData.object_description;

  }
}
